import zodFlexUser from '@/schemas/misc/zod-FlexUser.js';
import { BaseApi } from '@/services/api/base-api.ts';
import { z } from 'zod';

export type FlexUser = z.infer<typeof zodFlexUser>;

export class UserApi extends BaseApi {
  constructor() {
    super();
  }

  async getMyInfo() {
    return this.requestAsync({ schema: zodFlexUser, url: 'user/me' });
  }
}
